<template>
  <b-sidebar
    shadow
    visible
    backdrop
    no-header
    class="show"
    body-class="cp-sidebar__body"
    sidebar-class="cp-sidebar full-height item-tracking"
    @change="toggleScrollbar()"
  >
    <OrderTracking :item="item" @clear="toggleScrollbar" />
  </b-sidebar>
</template>

<script>
import {toggleBodyScrollbar} from '@/utils'

const OrderTracking = () => import('@/components/Order/OrderTracking')

export default {
  name: 'TrackingSidebar',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {OrderTracking},
  methods: {
    toggleScrollbar: function() {
      toggleBodyScrollbar()
      this.$emit('clear')
    }
  },
  created() {
    toggleBodyScrollbar(true)
  }
}
</script>

<style scoped>

</style>
